<template>
  <QList>
    <QItemLabel header>{{ t("CORE.DEVELOPER.@GENERAL") }}</QItemLabel>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.userId)">
      <QItemSection>{{ t("CORE.DEVELOPER.@ID") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.userId }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.appVersion)">
      <QItemSection>{{ t("CORE.DEVELOPER.@VERSION") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.appVersion }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.environment)">
      <QItemSection>{{ t("CORE.DEVELOPER.@ENVIRONMENT") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.environment }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', environmentInfos.branchName)">
      <QItemSection>{{ t("CORE.DEVELOPER.@BRANCH_NAME") }}</QItemSection>
      <QItemSection avatar>{{ environmentInfos.branchName }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', environmentInfos.commitId)">
      <QItemSection>{{ t("CORE.DEVELOPER.@COMMIT_ID") }}</QItemSection>
      <QItemSection avatar>{{ environmentInfos.commitId }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', environmentInfos.commitDate)">
      <QItemSection>{{ t("CORE.DEVELOPER.@COMMIT_DATE") }}</QItemSection>
      <QItemSection avatar>{{ environmentInfos.commitDate }}</QItemSection>
    </QItem>
    <QSeparator spaced />
    <QItemLabel header>{{ t("CORE.DEVELOPER.@API") }}</QItemLabel>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.comet.branchName)">
      <QItemSection>{{ t("CORE.DEVELOPER.@BRANCH_NAME") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.comet.branchName }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.comet.version)">
      <QItemSection>{{ t("CORE.DEVELOPER.@VERSION") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.comet.version }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.comet.commitId)">
      <QItemSection>{{ t("CORE.DEVELOPER.@COMMIT_ID") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.comet.commitId }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.comet.commitDate)">
      <QItemSection>{{ t("CORE.DEVELOPER.@COMMIT_DATE") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.comet.commitDate }}</QItemSection>
    </QItem>
    <QSeparator spaced />
    <QItemLabel header>{{ t("CORE.DEVELOPER.@LEGACY_API") }}</QItemLabel>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.core.branchName)">
      <QItemSection>{{ t("CORE.DEVELOPER.@BRANCH_NAME") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.core.branchName }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.core.version)">
      <QItemSection>{{ t("CORE.DEVELOPER.@VERSION") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.core.version }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.core.commitId)">
      <QItemSection>{{ t("CORE.DEVELOPER.@COMMIT_ID") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.core.commitId }}</QItemSection>
    </QItem>
    <QItem v-ripple clickable @click="emit('copy', applicationInfos.core.commitDate)">
      <QItemSection>{{ t("CORE.DEVELOPER.@COMMIT_DATE") }}</QItemSection>
      <QItemSection avatar>{{ applicationInfos.core.commitDate }}</QItemSection>
    </QItem>
  </QList>
</template>

<script setup>
  import { QSeparator } from "quasar";
  import { defineProps, defineEmits } from "vue";
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();

  const { applicationInfos, environmentInfos } = defineProps({
    applicationInfos: {
      type: Object,
      default: () => ({}),
    },
    environmentInfos: {
      type: Object,
      default: () => ({}),
    },
  });

  const emit = defineEmits(["copy"]);
</script>
